import React from 'react'
import { useRouter } from 'next/router'
import { useTrans } from 'hooks'
import { ProvinciaNode, RegioneNode, RivenditoreStoreLocatorNode } from '@gql/graphql-get'
import { JsonLd } from '@components/atoms'
import { ListingHead, Page, StoreLocator, StoreLocatorGeoList } from 'components/organisms'
import styles from './StoreLocatorTemplate.module.sass'

interface Props {
  pagina?: any
  regioni?: RegioneNode[]
  rivenditori?: RivenditoreStoreLocatorNode[]
  rivenditoriFiltered?: RivenditoreStoreLocatorNode[]
  province?: ProvinciaNode[]
}

const StoreLocatorTemplate = (props: Props) => {
  const {
    pagina = {},
    regioni = [],
    rivenditori = [],
    province = [],
    rivenditoriFiltered = [],
  } = props

  const t = useTrans()
  const router = useRouter()
  const storeLocatorRouteKey = router.asPath.split('?')[0].split('#')[0].replace(/\/$/, '')

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <ListingHead pagina={pagina} />
      <main className={styles.layout}>
        <StoreLocator
          key={storeLocatorRouteKey}
          item={{
            name: t('Trova il rivenditore più vicino a te'),
          }}
          rivenditori={rivenditori}
          rivenditoriFiltered={rivenditoriFiltered}
        />
        <StoreLocatorGeoList
          title={
            province && province.length > 0 ? t('Ricerca per provincia') : t('Ricerca per regione')
          }
          items={province && province.length > 0 ? province : regioni}
          showBackCta={(province?.length ?? 0) > 0}
        />
      </main>
      <JsonLd type="organization" />
    </Page>
  )
}

export default StoreLocatorTemplate
